/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Chain_Events_HelpInputs */

const en_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end time of the previous event will automatically update to match the start time of the selected event.`)
};

const fr_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'heure de fin de l'événement précédent est automatiquement mise à jour pour correspondre au début de l'événement sélectionné.`)
};

const de_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Endzeit des vorherigen Ereignisses wird automatisch aktualisiert, um der Startzeit des ausgewählten Ereignisses zu entsprechen.`)
};

const it_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ora di fine dell'evento precedente verrà aggiornata automaticamente in modo che corrisponda all'ora di inizio dell'evento selezionato.`)
};

const ru_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время окончания предыдущего события автоматически обновится, чтобы соответствовать времени начала выбранного события.`)
};

const es_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La hora de finalización del evento anterior se actualizará automáticamente para coincidir con la hora de inicio del evento seleccionado.`)
};

const zh_cn2_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前一个事件的结束时间将自动更新，以匹配所选事件的开始时间。`)
};

const ja_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントの終了時刻は、選択したイベントの開始時刻に合わせて自動的に更新されます。`)
};

const hi_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले इवेंट का समाप्ति समय स्वचालित रूप से अपडेट होकर चयनित इवेंट के प्रारंभ समय से मेल खाएगा।`)
};

const pt_pt2_options_editor_auto_chain_events_help = /** @type {(inputs: Options_Editor_Auto_Chain_Events_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O horário de término do evento anterior será atualizado automaticamente para corresponder ao horário de início do evento selecionado.`)
};

/**
* | output |
* | --- |
* | "The end time of the previous event will automatically update to match the start time of the selected event." |
*
* @param {Options_Editor_Auto_Chain_Events_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_chain_events_help = /** @type {((inputs?: Options_Editor_Auto_Chain_Events_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Chain_Events_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_chain_events_help(inputs)
	if (locale === "de") return de_options_editor_auto_chain_events_help(inputs)
	if (locale === "it") return it_options_editor_auto_chain_events_help(inputs)
	if (locale === "ru") return ru_options_editor_auto_chain_events_help(inputs)
	if (locale === "es") return es_options_editor_auto_chain_events_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_chain_events_help(inputs)
	if (locale === "ja") return ja_options_editor_auto_chain_events_help(inputs)
	if (locale === "hi") return hi_options_editor_auto_chain_events_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_chain_events_help(inputs)
	return en_options_editor_auto_chain_events_help(inputs)
});